import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { statusType } from '../../../../utils/statusTypes'
import apiService from '../../../../utils/api/service'
import Layout from '../../Layout'
import Box from '../../../Shared/Box'
import Input from '../../../Shared/Form/Input'
import Select from '../../../Shared/Form/Select'
import Button from '../../../Shared/Form/Button'
import Alert from '../../../Shared/Alert'

const CreateListPage = () => {
  const { i18n, t } = useTranslation()

  const [form, setForm] = useState({
    supplierId: { value: null, isValid: true, isRequired: true },
    eMailAddress: { value: '' },
  })
  const initialResponseState = {
    supplierId: { value: null },
    eMailAddress: { value: '' },
    errorMessage: { value: '' },
  }
  const [response, setResponse] = useState(initialResponseState)
  const [suppliers, setSuppliers] = useState([])
  const [status, setStatus] = useState(statusType.idle)

  const createSupplierListJob = async () => {
    const supplierId = form.supplierId.value
    const eMail = form.eMailAddress.value

    setResponse(initialResponseState)
    setStatus(statusType.loading)
    const { fetchPromise } = apiService.createSupplierList(supplierId, eMail)
    return await fetchPromise.then(response => {
      setResponse(prevState => {
        const draftState = { ...prevState }
        draftState.supplierId.value = response.supplierId
        draftState.eMailAddress.value = response.eMailAddress
        return draftState
      })
      setStatus(statusType.success)
    }).catch(error => {
        setResponse(prevState => {
          const draftState = { ...prevState }
          draftState.errorMessage.value = error.message
          return draftState
        })
        setStatus(statusType.error)
      },
    )
  }

  useEffect(() => {
    const fetchAllSuppliers = async () => {
      const { fetchPromise } = apiService.fetchAllSuppliers()
      let suppliers = await fetchPromise

      // Add joinedIdAndName property to the supplier
      suppliers = suppliers.map(supplier => {
        supplier.joinedIdAndName = `${supplier.name} (${supplier.id})`
        return supplier
      })

      return suppliers
    }

    (async () => {
      const suppliers = await fetchAllSuppliers()
      suppliers.sort((a, b) => {
        return new Intl.Collator(i18n.language).compare(a.joinedIdAndName, b.joinedIdAndName)
      })

      const firstSupplierId = suppliers[0].id
      setForm(prevState => {
        const draftState = { ...prevState }
        draftState.supplierId.value = parseInt(firstSupplierId)
        return draftState
      })

      setSuppliers(suppliers)
    })()
  }, [i18n.language])

  const onSupplierChange = (e) => {
    setForm(prevState => {
      const draftState = { ...prevState }
      draftState.supplierId.value = parseInt(e.target.value)
      return draftState
    })
  }

  const onEMailAddressChange = (e) => {
    setForm(prevState => {
      const draftState = { ...prevState }
      draftState.eMailAddress.value = e.target.value
      return draftState
    })
  }

  const onSubmit = (e) => {
    e.preventDefault()
    createSupplierListJob()
  }

  return (
    <Layout>
      <div className="page create-list-page">
        <Box>
          <h2>{t('CREATE_LIST')}</h2>
          <h4>{t('CREATE_LIST_SUBTEXT')}</h4>
          <form className={'form-with-button'} onSubmit={onSubmit}>
            <Input label={t('E_MAIL_ADDRESS')}
                   type="text"
                   id="email"
                   name="eMail"
                   value={form.eMailAddress.value}
                   onChange={onEMailAddressChange}
                   placeholder={'@giata.com'}
            />
            <Select label={'Supplier'}
                    onChange={onSupplierChange}
                    valid={form.supplierId.isValid}
                    optionLabelKey={'joinedIdAndName'}
                    optionValueKey={'id'}
                    options={suppliers}
                    selected={form.supplierId.value}
                    required={form.supplierId.isRequired}
            />
            <ul className={'caption'}>
              <li>* {t('REQUIRED').toLowerCase()}</li>
            </ul>
            {status === statusType.success &&
              <Alert type={status === statusType.error ? 'danger' : status === statusType.success ? 'success' : 'info'}>
                {t('JOB_CREATED', { supplierId: response.supplierId.value }) + (response.eMailAddress.value !== '' ? t('EMAIL_NOTIFICATION', { eMailAddress: response.eMailAddress.value }) : '')}
              </Alert>
            }
            {status === statusType.error &&
              <Alert type={'danger'}>
                {response.errorMessage.value}
              </Alert>
            }
            <Button
              classNames={'button-create'}
              align={'right'}
              type={'submit'}
              disabled={status === statusType.loading}
            >{t('CREATE')}</Button>
          </form>
        </Box>
      </div>
    </Layout>
  )
}

export default CreateListPage
